webpackJsonp(["pages.explore.projects"],{

/***/ "./filterable_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Makes search request for content when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var FilterableList = function () {
  function FilterableList(form, filter, holder) {
    var filterInputField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'filter_groups';

    _classCallCheck(this, FilterableList);

    this.filterForm = form;
    this.listFilterElement = filter;
    this.listHolderElement = holder;
    this.filterInputField = filterInputField;
    this.isBusy = false;
  }

  _createClass(FilterableList, [{
    key: 'getFilterEndpoint',
    value: function getFilterEndpoint() {
      return this.filterForm.getAttribute('action') + '?' + $(this.filterForm).serialize();
    }
  }, {
    key: 'getPagePath',
    value: function getPagePath() {
      return this.getFilterEndpoint();
    }
  }, {
    key: 'initSearch',
    value: function initSearch() {
      // Wrap to prevent passing event arguments to .filterResults;
      this.debounceFilter = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(this.onFilterInput.bind(this), 500);

      this.unbindEvents();
      this.bindEvents();
    }
  }, {
    key: 'onFilterInput',
    value: function onFilterInput() {
      var $form = $(this.filterForm);
      var queryData = {};
      var filterGroupsParam = $form.find('[name="' + this.filterInputField + '"]').val();

      if (filterGroupsParam) {
        queryData[this.filterInputField] = filterGroupsParam;
      }

      this.filterResults(queryData);

      if (this.setDefaultFilterOption) {
        this.setDefaultFilterOption();
      }
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.listFilterElement.addEventListener('input', this.debounceFilter);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.listFilterElement.removeEventListener('input', this.debounceFilter);
    }
  }, {
    key: 'filterResults',
    value: function filterResults(params) {
      var _this = this;

      if (this.isBusy) {
        return false;
      }

      $(this.listHolderElement).fadeTo(250, 0.5);

      this.isBusy = true;

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.getFilterEndpoint(), {
        params: params
      }).then(function (res) {
        _this.onFilterSuccess(res, params);
        _this.onFilterComplete();
      }).catch(function () {
        return _this.onFilterComplete();
      });
    }
  }, {
    key: 'onFilterSuccess',
    value: function onFilterSuccess(response, queryData) {
      if (response.data.html) {
        this.listHolderElement.innerHTML = response.data.html;
      }

      // Change url so if user reload a page - search results are saved
      var currentPath = this.getPagePath(queryData);

      return window.history.replaceState({
        page: currentPath
      }, document.title, currentPath);
    }
  }, {
    key: 'onFilterComplete',
    value: function onFilterComplete() {
      this.isBusy = false;
      $(this.listHolderElement).fadeTo(250, 1);
    }
  }]);

  return FilterableList;
}();

/* harmony default export */ __webpack_exports__["a"] = (FilterableList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/explore/projects/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__projects_list__ = __webpack_require__("./projects_list.js");


document.addEventListener('DOMContentLoaded', function () {
  return new __WEBPACK_IMPORTED_MODULE_0__projects_list__["a" /* default */]();
});

/***/ }),

/***/ "./projects_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterable_list__ = __webpack_require__("./filterable_list.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Makes search request for projects when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var ProjectsList = function ProjectsList() {
  _classCallCheck(this, ProjectsList);

  var form = document.querySelector('form#project-filter-form');
  var filter = document.querySelector('.js-projects-list-filter');
  var holder = document.querySelector('.js-projects-list-holder');

  if (form && filter && holder) {
    var list = new __WEBPACK_IMPORTED_MODULE_0__filterable_list__["a" /* default */](form, filter, holder);
    list.initSearch();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ProjectsList);

/***/ })

},["./pages/explore/projects/index.js"]);


// WEBPACK FOOTER //
// pages.explore.projects.b5b34e79079ca7967cb3.bundle.js